export enum TripType {
  ONE_WAY = "one-way",
  ROUND_TRIP = "round-trip",
}

export enum AirportType {
  FROM = "from",
  TO = "to",
}

export enum CabinClass {
  ANY = "ANY",
  ECONOMY = "ECONOMY",
  PREMIUM_ECONOMY = "PEREMIUM_ECONOMY",
  FIRST_CLASS = "FIRST_CLASS",
  BUSINESS = "BUSINESS_CLASS",
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum FilterOptions {
  PRICE = "price",
  STOPS = "stops",
  AIRLINE = "airline",
}

export enum StopsOptions {
  ANY = "ANY",
  DIRECT = "DIRECT",
  ONE = "UP_TO_ONE",
}

export enum TravelPurpose {
  LEISURE = "leisure",
  BUSINESS = "business",
}

export enum ReservationType {
  PAST = "PAST",
  UPCOMING = "UPCOMING",
  REFUNDED = "REFUNDED",
}

export enum BannersPlacementSlug {
  HOMEPAGE_BELOW_SEARCH = "HOMEPAGE_BELOW_SEARCH",
  CHECKOUT = "CHECKOUT",
}
